import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from 'components/ui/use-toast';
import * as Api from '../api';
import * as Mappers from '../mappers';
import * as Types from '../types';

const useStart = () => {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: async (data: Types.IMutation.Start) => {
      const response = await Api.Start({
        testId: data.testId,
        inviteCode: data.inviteCode,
        identification: data.identification,
        consentAccepted: data.consentAccepted,
      });
      return Mappers.StartResponse(response.data);
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['attempt', 'single', data.attempt.id] });
    },
    onError: (error: any) => {
      toast.error('Error', {
        description: error?.response?.data?.message || 'Failed to start the test',
      });
    },
  });
};

export default useStart;
